import { render, staticRenderFns } from "./AdminEmEdit.vue?vue&type=template&id=705a532a&scoped=true"
import script from "./AdminEmEdit.vue?vue&type=script&lang=js"
export * from "./AdminEmEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminEmEdit.vue?vue&type=style&index=0&id=705a532a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a532a",
  null
  
)

export default component.exports